export default "__VITE_ASSET__Dcah1Pwc__"